import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import MobileGridDisplayDynamic300x250Gak from './gak/MobileGridDisplayDynamic300x250';
import MobileGridDisplayDynamic300x250Nitro from './nitro/MobileGridDisplayDynamic300x250';
const MobileGridDisplayDynamic300x250 = ({ safety ='off' , rowId  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(MobileGridDisplayDynamic300x250Gak, {
            safety: safety,
            rowId: rowId
        });
    }
    return /*#__PURE__*/ React.createElement(MobileGridDisplayDynamic300x250Nitro, {
        safety: safety,
        rowId: rowId
    });
};
MobileGridDisplayDynamic300x250.displayName = 'MobileGridDisplayDynamic300x250';
export default MobileGridDisplayDynamic300x250;
